import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import SignIn from '../components/auth/Login';
import Signup from '../components/auth/Signup';
import ForgotPassword from '../components/auth/ForgotPassword';
import { useAuth } from '../hooks/useAuth';

const Auth = () => {
  const { user } = useAuth();

  // If user is already authenticated, redirect to home page
  if (user) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <Routes>
          <Route path="login" element={<SignIn />} />
          <Route path="signup" element={<Signup />} />
          <Route path="forgot-password" element={<ForgotPassword />} />
          {/* Redirect to login if no matching route */}
          <Route path="*" element={<Navigate to="login" replace />} />
        </Routes>
      </div>
    </div>
  );
};

export default Auth;
